<template>
  <main class="app-main identity-stats-page">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">طلبات التصوير</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">طلبات التصوير</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row mt-4 g-2">
          <div 
            v-for="group in statusGroups"
            :key="group.key"
            class="col-xl-2 col-md-4 col-sm-6"
          >
            <div 
              class="stat-card" 
              @click="toggleGroup(group.key)"
              :class="[
                'stat-' + group.key,
                selectedGroup === group.key ? 'active' : ''
              ]"
            >
              <div class="stat-card-content">
                <div class="stat-icon">
                  <i :class="getGroupIcon(group.key)"></i>
                </div>
                <div class="stat-info">
                  <span class="stat-label">{{ group.label }}</span>
                  <span class="stat-number">{{ getGroupCount(group.statuses) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedGroup !== null" class="row mt-3 g-2">
          <div 
            v-for="status in getStatusesByGroup(selectedGroup)"
            :key="status"
            class="col-xl-2 col-md-4 col-sm-6"
          >
            <div 
              class="stat-card status-card" 
              @click="filterByStatus(status)"
              :class="[
                getStatusColor(status),
                searchStatus == status ? 'active' : ''
              ]"
            >
              <div class="stat-card-content">
                <div class="stat-icon">
                  <i :class="getStatusIcon(status)"></i>
                </div>
                <div class="stat-info">
                  <span class="stat-label">{{ orderStatus[status] }}</span>
                  <span class="stat-number">{{ stats[status] || 0 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Filter Alert -->
        <div v-if="searchStatus || selectedGroup" class="row mt-3">
          <div class="col-12">
            <div class="alert alert-info py-2 d-flex justify-content-between align-items-center">
              <div>
                <span v-if="searchStatus">
                  فلترة حسب الحالة:
                  <strong>{{ orderStatus[searchStatus] }}</strong>
                </span>
                <span v-if="selectedGroup" class="ms-3">
                  ({{ getGroupLabel(selectedGroup) }})
                </span>
              </div>
              <button type="button" class="btn-close" @click="clearFilter"></button>
            </div>
          </div>
        </div>
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchClientMobile" class="form-control" placeholder="جوال العميل">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchProviderMobile" class="form-control" placeholder="جوال المزود">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchRegion" @change="getCitiesList">
                      <option :value="null">المنطقة</option>
                      <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="citiesSelect" class="form-control" v-model="searchCity">
                      <option :value="null">المدينة</option>
                      <option v-for="r in citiesList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchStatus">
                      <option :value="null">حالة الطلب</option>
                      <option v-for="(val, key) in orderStatus" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
    
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
    
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">طلبات التصوير</div>
                  <span v-if="countRows > 0"
                    class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                    عدد النتائج ( {{ countRows }} )
                  </span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>العميل</th>
                            <th>المزود</th>
                            <th>الخدمة</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.User.name }}<br/>{{ row.User.mobile }}</td>
                            <td>
                              {{ (row.Provider)? row.Provider.name : 'لا يوجد' }}
                              <div v-if="row.Provider">{{ row.Provider.mobile }}</div>
                            </td>
                            <td>{{ row.MaintenanceIssue.name }}</td>
                            <td>{{ orderStatus[row.status] }}</td>
                            <td>{{ $shortDate(row.updatedAt) }}</td>
                            <td>
                              <router-link :to="`/photos/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('photos_orders_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('photos_orders_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, checkAccess } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'PhotosList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      orderStatus: {},
      regionsList: [],
      citiesList: [],
      searchClientMobile: this.$route.query.cMobile || '',
      searchProviderMobile: this.$route.query.pMobile || '',
      searchStatus: this.$route.query.status || null,
      searchRegion: this.$route.query.region || null,
      searchCity: this.$route.query.city || null,
      stats: {},
      selectedGroup: null,
      statusGroups: [
        {
          key: 'admin',
          label: 'الإدارة',
          statuses: ['new', 'under_review', 'done'],
        },
        {
          key: 'client',
          label: 'العميل',
          statuses: [
            'waiting_deposit',
            'waiting_payment',
            'deposit_issue',
            'payment_issue',
            'client_canceled',
          ]
        },
        {
          key: 'provider',
          label: 'المزود',
          statuses: [
            'assigned',
            'arrived',
            'hold',
            'provier_canceled',
          ]
        }
      ],
      showDateFilter: false,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      countRows: 0,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchClientMobile.trim() != '')
        urlQuery.push(`cMobile=${this.searchClientMobile.trim()}`);
      if(this.searchProviderMobile.trim() != '')
        urlQuery.push(`pMobile=${this.searchProviderMobile.trim()}`);
      if(this.searchStatus !== null)
        urlQuery.push(`status=${this.searchStatus}`);
      if(this.searchRegion)
        urlQuery.push(`regionId=${this.searchRegion}`);
      if(this.searchCity)
        urlQuery.push(`cityId=${this.searchCity}`);
      if(this.selectedGroup && !this.searchStatus){
        const statuses = this.getStatusesByGroup(this.selectedGroup);
        if(statuses.length){
          urlQuery.push(`status_in=${statuses.join(',')}`);
        }
      }
      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);

      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);
      
      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchClientMobile !== null && this.searchClientMobile !== '' && this.searchClientMobile !== false ? { cMobile: this.searchClientMobile } : {}),
        ...(this.searchProviderMobile !== null && this.searchProviderMobile !== '' && this.searchProviderMobile !== false ? { pMobile: this.searchProviderMobile } : {}),
        ...(this.searchStatus !== null && this.searchStatus !== '' && this.searchStatus !== false ? { status: this.searchStatus } : {}),
        ...(this.searchRegion !== null && this.searchRegion !== '' && this.searchRegion !== false ? { region: this.searchRegion } : {}),
        ...(this.searchCity !== null && this.searchCity !== '' && this.searchCity !== false ? { city: this.searchCity } : {}),
        ...(this.searchDateFrom !== null && this.searchDateFrom !== '' && this.searchDateFrom !== false ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo !== null && this.searchDateTo !== '' && this.searchDateTo !== false ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/photos/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.orderStatus = data.orderStatus;
        this.regionsList = data.regionsList;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/photos/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    getCitiesList(){
      this.citiesList = [];
      this.searchCity = null;
      if(!this.searchRegion){
        this.$nextTick(() => {
          this.applySelect2Cities();
        });
        return;
      }
      this.$http.get(`/api/admin/cities/list?regionId=${this.searchRegion}&all=1`).then(({data}) => {
        this.citiesList = data.cities;
        this.$nextTick(() => {
          this.applySelect2Cities();
        });
      }).catch(() => {});
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchClientMobile = '';
      this.searchProviderMobile = '';
      this.searchStatus = null;
      this.searchRegion = null;
      this.searchCity = null;
      this.selectedGroup = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.citiesList = [];
      this.$router.replace({ query: {} }).catch(() => {});
      this.$nextTick(() => {
        this.applySelect2Cities();
      });
      this.getList();
      this.getStats();
    },
    getStats(){
      let params = {};
      
      if(this.searchRegion)
        params.regionId = this.searchRegion;

      if(this.searchCity)
        params.cityId = this.searchCity;

      this.$http.get('/api/admin/orders/dashboardStats', {
        params: {
          orderType: 'photos',   
          ...params
        }
      })
      .then(({data}) => {
        this.stats = data.stats;   
      })
      .catch(() => {});
    },
    getGroupColor(key){
      const colors = {
        admin: 'stat-admin',
        client: 'stat-client',
        provider: 'stat-provider'
      };
      return colors[key] || 'stat-default';
    },
    getGroupIcon(key){
      const icons = {
        admin: 'bi bi-gear-fill',
        client: 'bi bi-person-fill',
        provider: 'bi bi-tools'
      };
      return icons[key] || 'bi bi-circle';
    },
    getStatusColor(status){
      const colors = {
        new: 'stat-new',
        under_review: 'stat-under_review',
        done: 'stat-done',
        assigned: 'stat-assigned',
        arrived: 'stat-arrived',
        hold: 'stat-hold',
        client_canceled: 'stat-client_canceled',
        provier_canceled: 'stat-provier_canceled',
        waiting_payment: 'stat-waiting_payment',
        payment_issue: 'stat-payment_issue',
        waiting_deposit: 'stat-waiting_deposit',
        deposit_issue: 'stat-deposit_issue',
        default: 'stat-default'
      };
      return colors[status] || colors.default;
    },
    getStatusIcon(status){
      const icons = {
        new: 'bi bi-plus-circle-fill',
        under_review: 'bi bi-hourglass-split',
        done: 'bi bi-check-circle-fill',
        assigned: 'bi bi-person-check-fill',
        arrived: 'bi bi-truck',
        hold: 'bi bi-pause-circle-fill',
        client_canceled: 'bi bi-x-circle-fill',
        provier_canceled: 'bi bi-x-circle-fill',
        waiting_payment: 'bi bi-cash-stack',
        payment_issue: 'bi bi-exclamation-circle-fill',
        waiting_deposit: 'bi bi-wallet-fill',
        deposit_issue: 'bi bi-exclamation-triangle-fill',
        default: 'bi bi-circle'
      };
      return icons[status] || icons.default;
    },
    filterByStatus(status){
      this.currentPage = 1;
      this.searchStatus = status;
      this.getList();
      this.getStats();
    },
    toggleGroup(key){
      const isSame = this.selectedGroup === key;
      this.selectedGroup = isSame ? null : key;
      if (!this.selectedGroup) {
        this.searchStatus = null;
        return;
      }
      const groupStatuses = this.getStatusesByGroup(this.selectedGroup);
      if (!groupStatuses.includes(this.searchStatus)) {
        this.searchStatus = null;
      }
      this.getList();
      this.getStats();
    },
    getStatusesByGroup(groupKey){
      const group = this.statusGroups.find(g => g.key === groupKey);
      return group ? group.statuses.filter(s => this.orderStatus[s]) : [];
    },
    getGroupCount(statuses){
      return statuses.reduce((sum, s) => {
        return sum + (this.stats[s] || 0);
      }, 0);
    },
    getGroupLabel(groupKey){
      const group = this.statusGroups.find(g => g.key === groupKey);
      return group ? group.label : '';
    },
    applySelect2Cities(){
      if(!this.$refs.citiesSelect){
        setTimeout(() => this.applySelect2Cities(), 200);
        return;
      }
      const myInstance = this;
      const $el = $(this.$refs.citiesSelect);
      if ($el.hasClass('select2-hidden-accessible')){
        $el.off('change.citiesSelect2');
        $el.select2('destroy');
      }
      $el.select2({ width: '100%' })
        .on('change.citiesSelect2', function () {
          const newVal = $(this).val() || null;
          if(newVal === myInstance.searchCity) return;
          myInstance.searchCity = newVal;
        });
    },
  },
  created(){
    this.getList();
    this.getStats();
    this.$nextTick(() => {
      this.applySelect2Cities();
    });
  }
}
</script>

<style scoped>
.stat-card {
  background: white;
  border-radius: 10px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
  min-height: 70px;
  display: flex;
  align-items: center;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  border-color: transparent;
}

.stat-card.active {
  border: 2px solid #0d6efd;
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.15);
}

.stat-card-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.stat-card:hover .stat-icon {
  transform: scale(1.05);
}

.stat-info {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.stat-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

.stat-number {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.stat-admin .stat-icon { 
  color: #6c757d; 
  background: rgba(108, 117, 125, 0.12); 
}
.stat-admin .stat-number { color: #6c757d; }
.stat-admin:hover { border-color: #6c757d; background: #f8f9fa; }

.stat-client .stat-icon { 
  color: #0d6efd; 
  background: rgba(13, 110, 253, 0.12); 
}
.stat-client .stat-number { color: #0d6efd; }
.stat-client:hover { border-color: #0d6efd; background: #f0f7ff; }

.stat-provider .stat-icon { 
  color: #fd7e14; 
  background: rgba(253, 126, 20, 0.12); 
}
.stat-provider .stat-number { color: #fd7e14; }
.stat-provider:hover { border-color: #fd7e14; background: #fff8f0; }

.stat-new .stat-icon { 
  color: #0d6efd; 
  background: rgba(13, 110, 253, 0.12); 
}
.stat-new .stat-number { color: #0d6efd; }
.stat-new:hover { border-color: #0d6efd; background: #f0f7ff; }

.stat-under_review .stat-icon { 
  color: #ffc107; 
  background: rgba(255, 193, 7, 0.12); 
}
.stat-under_review .stat-number { color: #ffc107; }
.stat-under_review:hover { border-color: #ffc107; background: #fffcf0; }

.stat-done .stat-icon { 
  color: #198754; 
  background: rgba(25, 135, 84, 0.12); 
}
.stat-done .stat-number { color: #198754; }
.stat-done:hover { border-color: #198754; background: #f0fdf4; }

.stat-assigned .stat-icon { 
  color: #0dcaf0; 
  background: rgba(13, 202, 240, 0.12); 
}
.stat-assigned .stat-number { color: #0dcaf0; }
.stat-assigned:hover { border-color: #0dcaf0; background: #f0faff; }

.stat-arrived .stat-icon { 
  color: #198754; 
  background: rgba(25, 135, 84, 0.12); 
}
.stat-arrived .stat-number { color: #198754; }
.stat-arrived:hover { border-color: #198754; background: #f0fdf4; }

.stat-hold .stat-icon { 
  color: #ffc107; 
  background: rgba(255, 193, 7, 0.12); 
}
.stat-hold .stat-number { color: #ffc107; }
.stat-hold:hover { border-color: #ffc107; background: #fffcf0; }

.stat-client_canceled .stat-icon { 
  color: #dc3545; 
  background: rgba(220, 53, 69, 0.12); 
}
.stat-client_canceled .stat-number { color: #dc3545; }
.stat-client_canceled:hover { border-color: #dc3545; background: #fdf0f2; }

.stat-provier_canceled .stat-icon { 
  color: #dc3545; 
  background: rgba(220, 53, 69, 0.12); 
}
.stat-provier_canceled .stat-number { color: #dc3545; }
.stat-provier_canceled:hover { border-color: #dc3545; background: #fdf0f2; }

.stat-waiting_payment .stat-icon { 
  color: #ffc107; 
  background: rgba(255, 193, 7, 0.12); 
}
.stat-waiting_payment .stat-number { color: #ffc107; }
.stat-waiting_payment:hover { border-color: #ffc107; background: #fffcf0; }

.stat-payment_issue .stat-icon { 
  color: #dc3545; 
  background: rgba(220, 53, 69, 0.12); 
}
.stat-payment_issue .stat-number { color: #dc3545; }
.stat-payment_issue:hover { border-color: #dc3545; background: #fdf0f2; }

.stat-waiting_deposit .stat-icon { 
  color: #ffc107; 
  background: rgba(255, 193, 7, 0.12); 
}
.stat-waiting_deposit .stat-number { color: #ffc107; }
.stat-waiting_deposit:hover { border-color: #ffc107; background: #fffcf0; }

.stat-deposit_issue .stat-icon { 
  color: #dc3545; 
  background: rgba(220, 53, 69, 0.12); 
}
.stat-deposit_issue .stat-number { color: #dc3545; }
.stat-deposit_issue:hover { border-color: #dc3545; background: #fdf0f2; }

.stat-default .stat-icon { 
  color: #6c757d; 
  background: rgba(108, 117, 125, 0.12); 
}
.stat-default .stat-number { color: #6c757d; }
.stat-default:hover { border-color: #6c757d; background: #f8f9fa; }
</style>